module.exports = __webpack_public_path__ + "img/negotiations2019.74e77355.jpg";